import { cliente } from "../http/cliente";
import type {
  EmpresaReceita,
  ReceitaManualIn,
  ReceitaManualOut,
} from "./tipos";

/*
 * Fetchers da receita manual (Tela 5 §10.5 — consome o BE selado).
 *
 * Camada fina sobre o `cliente` HTTP (CP-C): injeta Bearer, trata refresh/401/503
 * e normaliza erro em `ErroHttp`. Estes fetchers NÃO tratam erro — propagam a
 * rejeição do `cliente` para o TanStack Query (hooks em `./hooks`) decidir.
 *
 * `baseURL` do cliente já é `/api`, então os paths aqui são relativos a ela.
 */

/**
 * `GET /api/receitas/empresas` — empresas sobre as quais o usuário pode lançar
 * receita manual (escopo de `criar_receita_manual`, resolvido pelo TOKEN no
 * backend). Array PURO (sem envelope). Espelha `GET /api/projecao/empresas`
 * (FE-B3) / `GET /api/conciliacao/empresas` (FE-B4) trocando a ação.
 */
export async function buscarEmpresasReceita(): Promise<EmpresaReceita[]> {
  const resposta = await cliente.get<EmpresaReceita[]>("/receitas/empresas");
  return resposta.data;
}

/**
 * `POST /api/empresas/{empresaId}/receitas/manual` (201).
 *
 * Lança uma conta-a-receber manual. O `empresaId` vai no PATH (isolamento IDOR
 * por path no backend). O corpo carrega EXATAMENTE os 3 campos de `ReceitaManualIn`
 * — `origem`/`erp_id`/`empresa_id` NUNCA são enviados (o backend é `extra=forbid`).
 * Devolve a `ReceitaManualOut` criada (com o CNPJ já mascarado).
 */
export async function criarReceitaManual(
  empresaId: string,
  dados: ReceitaManualIn,
): Promise<ReceitaManualOut> {
  // Monta o corpo com SÓ os 3 campos do contrato — defesa explícita contra vazar
  // qualquer campo extra que um caller pudesse anexar ao objeto.
  const corpo: ReceitaManualIn = {
    valor: dados.valor,
    data_prevista: dados.data_prevista,
    cnpj_contraparte: dados.cnpj_contraparte,
  };
  const resposta = await cliente.post<ReceitaManualOut>(
    `/empresas/${empresaId}/receitas/manual`,
    corpo,
  );
  return resposta.data;
}
